import React, { useEffect, useState } from 'react';
import BlazeInputDropdown, {
  BlazeDropdownItem,
} from '../../../../../../components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';

interface SelectParameterProps {
  selectedParamId: string | null;
  onSelect: (selectedParam: BlazeDropdownItem) => void;
  dataParamsList: BlazeDropdownItem[];
  setModalValue: (entityValue: string) => void;
}

/**
 * Input for selecting parameters.
 * @constructor
 */
const SelectParameterDropdown = (props: SelectParameterProps) => {
  const findSelected = () => {
    return props.dataParamsList.find((dpl: BlazeDropdownItem) => dpl.id === props.selectedParamId) as BlazeDropdownItem;
  };
  const [selected, setSelected] = useState<BlazeDropdownItem | null>(findSelected());
  useEffect(() => {
    setSelected(findSelected());
  }, [props.dataParamsList, props.selectedParamId]);

  return (
    <BlazeInputDropdown
      id={'selectParameterFilterDropdown'}
      onClick={props.onSelect}
      selected={selected}
      items={props.dataParamsList}
      isSearchable={true}
      dropDownFooter={{
        entity: 'Parameter',
        onClick: props.setModalValue,
        style: 'Text',
      }}
    />
  );
};

export default SelectParameterDropdown;
